import { render, staticRenderFns } from "./DeleteRegionWebDialog.vue?vue&type=template&id=745ad2d8&"
import script from "./DeleteRegionWebDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRegionWebDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports